var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbcWalletLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 40,
    viewBox: "0 0 67 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.3049 21.2334H60.0345C58.9542 22.7411 57.197 23.7053 55.2283 23.6394C52.19 23.5388 49.7309 20.9572 49.6864 17.8267C49.6403 14.5315 52.229 11.8364 55.4184 11.8364C57.5683 11.8364 59.4429 13.0605 60.4236 14.8681H66.3066C66.7775 14.8681 67.1062 14.3961 66.9623 13.935C65.3969 8.9072 60.8128 5.25708 55.4166 5.25708C55.0861 5.25708 54.7592 5.27171 54.4358 5.29733C54.3097 5.30465 54.1746 5.31563 54.0343 5.33026C50.367 5.7584 47.19 7.87894 45.2604 10.9125C43.0927 7.51119 39.3579 5.26074 35.122 5.26074C33.0503 5.26074 31.0976 5.79865 29.3901 6.7464V4.39532C29.3901 -0.537374 23.0007 0.0188349 23.0007 0.0188349V12.2426C22.409 11.0058 21.6254 9.88422 20.6891 8.92001C18.4947 6.66041 15.4635 5.26074 12.1213 5.26074C8.77917 5.26074 5.74973 6.66041 3.5536 8.92001C1.35925 11.1814 0 14.301 0 17.7425C0 21.184 1.35925 24.3036 3.5536 26.565C5.74795 28.8246 8.77917 30.2243 12.1213 30.2243C14.5005 30.2243 16.7232 29.5144 18.5978 28.2885C20.2822 30.5499 24.2427 30.206 24.2427 30.206V23.2424C26.2202 27.3737 30.3531 30.2243 35.122 30.2243C39.365 30.2243 43.1034 27.9647 45.2693 24.5561C45.2693 24.5561 45.2693 24.5561 45.2693 24.5579C47.3659 27.8494 50.9302 30.0687 54.9866 30.2151C60.4077 30.4091 65.0789 26.9145 66.8148 21.9836C66.9427 21.6195 66.6798 21.2334 66.3031 21.2334H66.3049ZM12.1213 23.6449C10.5418 23.6449 9.10788 22.9826 8.07023 21.9141C7.03258 20.8456 6.38937 19.369 6.38937 17.7425C6.38937 16.116 7.03258 14.6394 8.07023 13.5709C9.10788 12.5024 10.5418 11.8401 12.1213 11.8401C13.7009 11.8401 15.1348 12.5024 16.1724 13.5709C17.2101 14.6394 17.8533 16.116 17.8533 17.7425V19.81L16.1724 21.9141C15.1348 22.9826 13.7009 23.6449 12.1213 23.6449ZM39.1731 21.9141C38.1355 22.9826 36.7016 23.6449 35.122 23.6449C33.5424 23.6449 32.1086 22.9826 31.0709 21.9141C30.0333 20.8456 29.3901 19.369 29.3901 17.7425V15.6732L31.0709 13.5691C32.1086 12.5006 33.5424 11.8383 35.122 11.8383C36.7016 11.8383 38.1355 12.5006 39.1731 13.5691C40.2108 14.6376 40.854 16.1141 40.854 17.7407C40.854 19.3672 40.2108 20.8437 39.1731 21.9122V21.9141Z",
    fill: "url(#paint0_linear_13172_114709)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1213 29.8759C8.87333 29.8759 5.92739 28.5147 3.79523 26.3191C1.66129 24.1217 0.339355 21.0882 0.339355 17.7436C0.339355 14.3991 1.66129 11.3655 3.79346 9.16814C5.92739 6.97075 8.87155 5.61133 12.1195 5.61133C15.3675 5.61133 18.3135 6.97258 20.4456 9.16814C22.5796 11.3655 23.8997 14.3972 23.8997 17.7436C23.8997 21.09 22.5778 24.1217 20.4456 26.3173C18.3117 28.5147 15.3675 29.8741 12.1195 29.8741L12.1213 29.8759ZM12.1213 11.4918C10.4476 11.4918 8.93019 12.1925 7.83035 13.3251C6.73051 14.4576 6.04999 16.0201 6.04999 17.7436C6.04999 19.4671 6.73051 21.0297 7.83035 22.1622C8.93019 23.2947 10.4476 23.9955 12.1213 23.9955C13.7951 23.9955 15.3125 23.2947 16.4123 22.1622C17.5121 21.0297 18.1926 19.4671 18.1926 17.7436C18.1926 16.0201 17.5121 14.4576 16.4123 13.3251C15.3125 12.1925 13.7951 11.4918 12.1213 11.4918Z",
    fill: "url(#paint1_linear_13172_114709)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1218 29.8744C28.6258 29.8744 23.3398 24.4313 23.3398 17.7421C23.3398 17.6232 23.3416 17.5043 23.3452 17.3872L23.3558 17.0267H23.3398V0.353269C23.4074 0.353269 23.4855 0.349609 23.5708 0.349609C25.2179 0.349609 29.0487 0.744811 29.0487 4.39676V7.33332L29.5498 7.05522C31.2519 6.1093 33.1798 5.60981 35.12 5.60981C41.616 5.60981 46.902 11.053 46.902 17.7421C46.902 24.4313 41.616 29.8744 35.12 29.8744H35.1218ZM35.1218 11.4903C31.7743 11.4903 29.0505 14.2951 29.0505 17.7421C29.0505 21.1891 31.7743 23.994 35.1218 23.994C38.4693 23.994 41.1931 21.1891 41.1931 17.7421C41.1931 14.2951 38.4693 11.4903 35.1218 11.4903Z",
    fill: "url(#paint2_linear_13172_114709)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3901 6.74543V15.6722L31.071 13.5681C32.1086 12.4996 33.5425 11.8373 35.1221 11.8373V5.25977C33.0503 5.25977 31.0976 5.79768 29.3901 6.74543Z",
    fill: "url(#paint3_linear_13172_114709)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8531 25.8282V19.8105L16.1722 21.9146C15.1345 22.9831 13.7007 23.6455 12.1211 23.6455V30.2248C14.5002 30.2248 16.723 29.5149 18.5975 28.2891C18.1427 27.678 17.8531 26.8784 17.8531 25.83V25.8282Z",
    fill: "url(#paint4_linear_13172_114709)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3046 21.2327H60.4519C60.2333 21.5657 59.9828 21.8768 59.7092 22.1604C58.6093 23.2929 57.0919 23.9937 55.4182 23.9937C53.7444 23.9937 52.2271 23.2929 51.1272 22.1604C50.0274 21.0278 49.3469 19.4653 49.3469 17.7418C49.3469 16.0183 50.0274 14.4558 51.1272 13.3232C52.2271 12.1907 53.7444 11.4899 55.4182 11.4899C57.0919 11.4899 58.6111 12.1907 59.7092 13.3232C60.148 13.7752 60.5158 14.2966 60.8037 14.8693H66.3064C66.509 14.8693 66.6831 14.7778 66.8075 14.6406C66.2673 12.5402 65.1941 10.6611 63.7443 9.16814C61.6103 6.97075 58.6662 5.61133 55.4164 5.61133C52.1667 5.61133 49.2225 6.97258 47.0903 9.16814C44.9564 11.3655 43.6362 14.3972 43.6362 17.7436C43.6362 21.09 44.9582 24.1217 47.0903 26.3173C49.2243 28.5147 52.1684 29.8741 55.4164 29.8741C58.6644 29.8741 61.6103 28.5129 63.7443 26.3173C65.0716 24.9506 66.0843 23.2582 66.66 21.37C66.5658 21.2858 66.4432 21.2327 66.3046 21.2327Z",
    fill: "url(#paint5_linear_13172_114709)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M52.8206 12.4831C52.8206 12.4831 52.8206 12.4703 52.8206 12.4648C52.6536 12.5527 52.4919 12.6478 52.3356 12.7503C50.3384 14.0091 49.0858 16.1259 48.1636 18.5319C47.1811 21.0971 46.2482 23.0438 45.271 24.5551C46.664 26.7433 48.7056 28.4595 51.1096 29.4054C51.5253 27.036 51.8469 24.7344 52.0957 22.5388C50.66 21.4795 49.7112 19.7596 49.6828 17.8275C49.649 15.4984 50.9372 13.473 52.8188 12.485L52.8206 12.4831Z",
    fill: "url(#paint6_linear_13172_114709)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8196 39.9985L21.7837 35.4902H22.5051L22.951 37.6602L23.2584 39.1587H23.278L23.6298 37.6602L24.1504 35.4902H24.9411L25.4563 37.6602L25.801 39.1532H25.8206L26.1404 37.6602L26.5988 35.4902H27.2953L26.2168 39.9985H25.4208L24.8629 37.6657L24.536 36.2971H24.5235L24.1913 37.6657L23.6209 39.9985H22.8249H22.8196Z",
    fill: "#58595B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6304 39.9985L30.2359 38.7781H28.5995L28.2175 39.9985H27.4961L28.9886 35.4902H29.8788L31.3713 39.9985H30.6304ZM29.4328 36.1617H29.4008L28.7665 38.1524H30.0582L29.431 36.1617H29.4328Z",
    fill: "#58595B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0483 39.9985V35.4902H32.7573V39.3544H34.5394V40.0003H32.0483V39.9985Z",
    fill: "#58595B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2661 39.9985V35.4902H35.9751V39.3544H37.7572V40.0003H35.2661V39.9985Z",
    fill: "#58595B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4839 39.9985V35.4902H41.2877V36.1361H39.1928V37.3894H41.094V38.0353H39.1928V39.3526H41.2877V39.9985H38.4839Z",
    fill: "#58595B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8281 36.1361V39.9985H43.1191V36.1361H41.8149V35.4902H45.134V36.1361H43.8298H43.8281Z",
    fill: "#58595B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13172_114709",
    x1: 0,
    y1: 15.1133,
    x2: 66.3208,
    y2: 15.1133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13172_114709",
    x1: 3.42921,
    y1: 8.79306,
    x2: 5.92925,
    y2: 11.2209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13172_114709",
    x1: 20.7333,
    y1: 2.92756,
    x2: 23.8496,
    y2: 5.9521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13172_114709",
    x1: 29.3901,
    y1: 10.4669,
    x2: 34.7276,
    y2: 10.4669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ED1C24",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#ED1C24",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#ED1C24",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#ED1C24",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#ED1C24",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1C24",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13172_114709",
    x1: 12.1211,
    y1: 25.0159,
    x2: 18.1516,
    y2: 25.0159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#ED1C24",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ED1C24",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#ED1C24",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#ED1C24",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#ED1C24",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_13172_114709",
    x1: 46.7261,
    y1: 8.79123,
    x2: 49.2261,
    y2: 11.2191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_13172_114709",
    x1: 44.3115,
    y1: 18.4477,
    x2: 52.929,
    y2: 21.0875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbcWalletLogo);
export default __webpack_public_path__ + "static/media/abc_wallet_logo.d8d48f22976024895415aabd81bd1078.svg";
export { ForwardRef as ReactComponent };